import axios from 'axios';
import application from '../application'
import * as Msal from 'msal'

export default class authentication {

    constructor(app) {
        let self = this;

        /** @type application */
        this.app = app;
        this.enabled = true;
        this.language = 'es';

        this.authService = null;

        // Shadow data
        this.isLogged = false;
        this.email = null;
        this.idToken = null;

        $(document).ready(function () {
            self.attachAuthentication();
            self.refreshData();
        })
    }

    async tryLogin() {
        var self = this;

        if (await this.tryLoginSilently() === false) {
            this.tryLoginRedirect()
        }
    }

    attachAuthentication() {
        if (window.Unex && window.Unex.Authentication) {
            window.Unex.Authentication.tokenRequired = true;
            this.authService = window.Unex.Authentication;
            var self = this;

            window.Unex.Authentication.on('login', function () {
                self.refreshData()
            });
            window.Unex.Authentication.on('logout', function () {
                self.refreshData()
            });
            self.refreshData();
        }
    }

    refreshData() {
        if (!this.authService) return;

        this.isLogged = this.authService.isLogged;
        this.email = this.authService.email;
        this.idToken = this.authService.idToken;
        if (this.isLogged) this.app.acceptConditions(true);

        // GA4:
        try {
            this.sendAnalyticsInfo()
        } catch (e) { }
    }
    sendAnalyticsInfo() {
        if (!this.app.analytics) return;       // Analytics not initialized

        var userType = 'not_logged'
        var userID = null
        var user = window.Unex.Authentication.user

        if (this.isLogged && user.employee == true) {
            userType = 'employee'
            userID = user.id
        } else if (this.isLogged) {
            userType = 'logged'
            userID = user.id
        }

        // GA4
        this.app.analytics.setUserProperties({
            'userType': userType,    // categorizar tipo de usuario: employee, logged, not_logged
            'userID': userID
        })

    }
    async login() {
        if (!this.authService) return;

        return await this.authService.login();
    }

    async loginRedirect(redirectToHome = false) {
        if (!this.authService) return;

        return await this.authService.login(false, true);
    }

    async register() {
        if (!this.authService) return;

        return await this.authService.login(false, true, true);
    }

}

// export const auth = new authentication();
